'use client'

import { useEffect } from 'react'

import useCouponStore from '@/app/book/stores/useCouponStore'
import { useClickId } from '@/hooks/useClickId'
import { useShipParams } from '@/hooks/useShipParams'

const SearchParamsListener = (): null => {
  useClickId()

  const { coupon } = useShipParams()
  const setCoupon = useCouponStore((store) => store.setCoupon)

  useEffect(() => {
    if (coupon) setCoupon(coupon)
  }, [coupon, setCoupon])

  return null
}

export default SearchParamsListener
